import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';

import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';

import { localizable } from '../../../components/Localization';
import { FooterContainer } from '../../../components/PanelFooter';
import OfferNotificationsList from './OfferNotificationsList';
import OfferNotificationStore from '../stores/OfferNotificationStore';

@inject('user')
@localizable
class OfferNotificationsPanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
  };

  constructor(props) {
    super(props);
    this.store = new OfferNotificationStore(props.user, props.offer);
  }

  componentDidMount() {
    this.store.load();
  }

  handleRefresh = () => {
    this.store.load();
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { t, offer } = this.props;

    return (
      <div>
        <Panel
          headerText={
            t('Notifications') +
            ': ' +
            offer.buyer.buyer_lastName +
            ', ' +
            offer.buyer.buyer_firstName
          }
          type={PanelType.large}
          isOpen={this.props.isOpen}
          onDismiss={this.handleClose}
          onRenderFooterContent={() => this.renderPanelFooterContent()}
          isFooterAtBottom={true}
          closeButtonAriaLabel="Close"
        >
          <OfferNotificationsList store={this.store} />
        </Panel>
      </div>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <FooterContainer>
        <DefaultButton onClick={this.handleRefresh}>
          {t('Refresh')}
        </DefaultButton>
        <PrimaryButton onClick={this.handleClose}>{t('Close')}</PrimaryButton>
      </FooterContainer>
    );
  };
}

export default OfferNotificationsPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/OfferNotificationsPanel.jsx